<template>
  <div>
    <ShippingHeaderList @fetch="pagination" @search="search" :title="$t('cadastro-transportadora')" :total="total" :pagination="true" />
    <el-card>
      <ShippingHeaderSearch @fetch="search" redirect="shipping.add"/>
      <ShippingTable :tableData="tableData" />
    </el-card>
  </div>
</template>
<script>
import ShippingHeaderList from "./components/ShippingHeaderList.vue";
import ShippingTable from "./components/ShippingTable.vue";
import ShippingHeaderSearch from "./components/ShippingHeaderSearch.vue";
import { ShippingService } from "@/services/shipping/shipping.services";

export default {
  name: "ShippingPage",
  methods: {
    pagination(records, page) {
      this.filter.records = records;
      this.filter.page = page;
      this.fetch();
    },
    search(filter) {
      this.filter.word = filter;
      this.fetch();
    },
    fetch() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      ShippingService.list(vm.filter.records, vm.filter.page, vm.filter.word)
        .then((response) => {
          vm.tableData = response.records;
          vm.total = response.total;
        })
        .catch((error) => {
          this.$message({
              type: "error",
              message: error,
          });
        })
        .finally(() => loading.close());
    },
  },
  mounted() {
    this.fetch();
  },
  data() {
    return {
      filter: {
        records: 50,
        page: 1,
        word: "",
      },
      total: 0,
      tableData: [],
    };
  },
  components: { ShippingHeaderList, ShippingHeaderSearch, ShippingTable }
};
</script>
